/* global require */

// Fix for addEventListener third `options` argument for IE11, needed by react-swipeable
// and some other libs
require("event-listener-with-options/js/polyfill");
